// @ts-nocheck
const PropertyType = {
    RANGE: "RANGE",
    NUMBER: "NUMBER",
    STRING: "STRING",
    MULTISELECT: "MULTISELECT",
    SINGLESELECT: "SINGLESELECT",
    NONE: "NONE"
}

let mPropertiesModal;
let errRequiredMsg = "Dies sind Pflichtfelder. Gib bitte mindestens einen Wert an.";
let errCompareMsg = "Der Wert im zweiten Feld darf nicht kleiner als der im ersten Feld sein.";
let errCanNotBeZeroMsg = "Wenn Du das erste Feld frei lässt, muss der Wert im zweiten Feld größer als 0 sein.";
let errInvalidMsg = "Bitte gib gültige Zahlen ein.";
/*enforceRequiredFields should enforce marking and filling out required fields,
but sometimes (e.g. TargetPrice) we don't want to fill every property*/

async function openPropertiesModal(baseUrl, readOnly, materialIdQuery, materialNameQuery, enforceRequiredFields = true, formId = null, catalogElementId = "catalogSelection") {
    let catalogId = $(`#${catalogElementId}-suggestions-select option:selected`).val();
    let materialId = document.querySelector(materialIdQuery.replaceAll("%s", catalogId)).value;
    let materialName = document.querySelector(materialNameQuery.replaceAll("%s", catalogId))?.innerText;
    return await openPropertiesModalNoQuery(baseUrl, readOnly, materialId, materialName, enforceRequiredFields, formId);
}

async function openPropertiesModalNoQuery(baseUrl, readOnly, materialId, materialName, enforceRequiredFields, formId = null, root = document) {
    mPropertiesModal = new MaterialPropertiesModal(baseUrl, readOnly, materialId, materialName, enforceRequiredFields, root);
    await mPropertiesModal.checkAndReloadDependencies();
    await mPropertiesModal.init();
    $('#materialPropertiesModal').on('hidden.bs.modal', function () {
        mPropertiesModal.resetContent();
        root.querySelector("#mp-loading-animation").style.display = "unset";
    });

    if (formId) {
        window.addEventListener("materialPropertiesSave", e => {
            let propertyDataInput = root.querySelector("#material-properties-input");
            if (!propertyDataInput) {
                propertyDataInput = document.createElement("input");
                propertyDataInput.id = "material-properties-input";
                propertyDataInput.setAttribute('type', 'hidden');
                propertyDataInput.setAttribute('name', 'materialProperties');
                root.querySelector("#" + formId).appendChild(propertyDataInput);
            }
            propertyDataInput.setAttribute('value', JSON.stringify(e.detail));
        });
    }
    return mPropertiesModal;
}

window.openPropertiesModalNoQuery = openPropertiesModalNoQuery;

const REQUIRED_FLAG = "REQUIRED";

class MaterialPropertiesModal {

    #baseUrl;
    #readOnly;
    #materialName;
    #materialId;
    fetchedProperties;
    fetchedPropsMapping;
    #orderIdx;
    #enforceRequiredFields;
    #root;

    constructor(baseUrl, readOnly, materialId, materialName, enforceRequiredFields = true, root = document.body) {
        this.#baseUrl = baseUrl;
        this.#readOnly = readOnly;
        this.#materialId = materialId;
        this.#materialName = materialName;
        this.fetchedProperties = [];
        this.fetchedPropsMapping = {};
        this.#orderIdx = 0;
        this.#enforceRequiredFields = enforceRequiredFields; // this is used e.g. for target prices where we do not necessarily want to select all material properties for a filter
        this.#root = root;
    }

    static fromQueries(baseUrl, readOnly, materialIdQuery, materialNameQuery, enforceRequiredFields = true, catalogElementId = "catalogSelection") {
        let catalogId = $(`#${catalogElementId}-suggestions-select option:selected`).val();
        let materialId = document.querySelector(materialIdQuery.replaceAll("%s", catalogId)).value;
        let materialName = document.querySelector(materialNameQuery.replaceAll("%s", catalogId))?.innerText;
        return new MaterialPropertiesModal(baseUrl, readOnly, materialId, materialName, enforceRequiredFields);
    }

    async init() {
        if (!await this.checkAndReloadDependencies()) {
            this.#stopLoadingSpinnerAndShowError("Bitte Seite neu laden!", true);
            return;
        }
        if (!this.#materialName || !this.#materialId) {
            this.#showNoProperties();
            this.#root.querySelector("#mp-loading-animation").style.display = "none";
            return;
        }

        this.#root.querySelector("#mp-header-text").innerText = "Materialeigenschaften für \"" + this.#materialName + "\" bearbeiten";

        let propertyDataInput = this.#root.querySelector("#material-properties-input");
        if (propertyDataInput && propertyDataInput.value) {
            try {
                const inputData = JSON.parse(propertyDataInput.value);
                if (Array.isArray(inputData)) {
                    this.fetchedProperties = inputData;
                    this.#parseRangeValues()
                    this.#initData();
                } else if (inputData.materialId === this.#materialId) {
                    this.fetchedProperties = inputData.data;
                    this.#parseRangeValues()
                    this.#initData();
                } else {
                    await this.#fetchProperties();
                }
            } catch (e) {
                await this.#fetchProperties();
            }
        } else {
            await this.#fetchProperties();
        }
    }

    async checkAndReloadDependencies() {
        const loadScript = (src) =>
          new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.src = src + '?' + Date.now();
              script.onload = () => resolve();
              script.onerror = () => reject();
              document.head.appendChild(script);
          });

        try {
            // Scripts
            if (typeof multiSelect === 'undefined') {
                console.warn('Wondergem not loaded, attempting reload...');
                await loadScript('/assets/wondergem/wondergem.js');
            }

            if (typeof window.tippy === 'undefined') {
                console.warn('Tippy not loaded, attempting reload...');
                await loadScript('/assets/js/tippy/popper.js');
                await loadScript('/assets/js/tippy/tippy.js');
            }

            // Stylesheets
            await this.#loadStylesheets('/assets/stylesheets/materialPropertiesModal.css')

            return true;
        } catch {
            return false;
        }
    }

    #loadStylesheets(href) {
        return new Promise((resolve, reject) => {
            const existing = document.querySelector(`link[data-dynamic-href="${href}"]`);
            if (existing) {
                resolve();
                return;
            }

            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = `${href}?${Date.now()}`;
            link.dataset.dynamicHref = href;
            link.onload = () => resolve();
            link.onerror = () => reject(new Error(`Failed to load stylesheet: ${href}`));
            document.head.appendChild(link);
        });
    }


    #parseRangeValues() {
        Object.keys(this.fetchedProperties).forEach(e => {
            if (this.fetchedProperties[e].type === 'RANGE' && this.fetchedProperties[e].value ) {
                if (this.fetchedProperties[e].value.from){
                    this.fetchedProperties[e].value.from = parseFloat(this.fetchedProperties[e].value.from);
                }
                if (this.fetchedProperties[e].value.to) {
                    this.fetchedProperties[e].value.to = parseFloat(this.fetchedProperties[e].value.to);
                }
            }
        } )
    }

    #initData() {
        if (this.fetchedProperties.length === 0) {
            this.#showNoProperties();
        } else {
            this.fetchedProperties.sort(function (a, b) {
                return a.priority - b.priority
            }).forEach(prop => {
                this.#initializeDataMapping(prop);
            });
            this.fetchedProperties.forEach(prop => {
                this.#addProperty(prop);
            });
        }
        this.#root.querySelector("#mp-loading-animation").style.display = "none";
    }

    #stopLoadingSpinnerAndShowError(message, showReloadButton = false) {
        console.log(message)
        this.#showNoPropertiesWithError(message, showReloadButton);
        this.#root.querySelector("#mp-loading-animation").style.display = "none";
    }

    /**
     * Fetch property data (incl. property list elements) for the given lot/material and material
     */
    async #fetchProperties() {
        $.ajax({
            url: `${this.#baseUrl}/material/${this.#materialId}/properties`,
            type: "GET",
            contentType: "application/json; charset=utf-8",
            success: (data) => {
                if (data.success) {
                    this.fetchedProperties = data.data;
                    this.#initData();
                } else {
                    this.#stopLoadingSpinnerAndShowError("An error occurred.");
                }
            },
            error: (message) => this.#stopLoadingSpinnerAndShowError(message)
        });

    }

    #initializeDataMapping(node) {
        node.idx = this.#orderIdx;
        this.#orderIdx++;
        this.fetchedPropsMapping[node.idx] = node;
        if (node.propertyListElementDTOs) {
            // Property
            node.propertyListElementDTOs.sort(function (a, b) {
                return a.priority - b.priority
            }).forEach(n => {
                this.#initializeDataMapping(n);
            })
        } else if (node.propertyChildren) {
            // PropertyListElement
            node.propertyChildren.sort(function (a, b) {
                return a.priority - b.priority
            }).forEach(n => {
                this.#initializeDataMapping(n);
            })
        }
    }

    /**
     *  Property cards generator function
     */
    #addProperty(prop, displayName = null) {
        const type = PropertyType[prop.type];
        if (type) {
            // Define properties by type
            const propsByType = {
                [PropertyType.RANGE]: () => {
                    const {id, card, action} = this.#getPropertyComponents(prop, displayName);
                    action.appendChild(this.#getNumberInputElement(`${id}-action-from`, "von", ["mp-range-input", "form-control"], prop.value?.from));
                    const dash = document.createElement("span");
                    dash.innerHTML = "&nbsp;&ndash;&nbsp;";
                    action.appendChild(dash);
                    action.appendChild(this.#getNumberInputElement(`${id}-action-to`, "bis", ["mp-range-input", "form-control"], prop.value?.to));
                    card.appendChild(action);
                    return card;
                },
                [PropertyType.NUMBER]: () => {
                    const {id, card, action} = this.#getPropertyComponents(prop, displayName);
                    action.appendChild(this.#getNumberInputElement(`${id}-action`, "Zahlenwert...", ["form-control"], prop.value));
                    card.appendChild(action);
                    return card;
                },
                [PropertyType.STRING]: () => {
                    const {id, card, action} = this.#getPropertyComponents(prop, displayName);
                    const textarea = document.createElement("textarea");
                    textarea.id = `${id}-action`;
                    textarea.rows = 2;
                    textarea.placeholder = prop.description;
                    textarea.disabled = this.#readOnly;
                    textarea.style.resize = "none";
                    textarea.classList.add("form-control");
                    if (prop.value) {
                        textarea.value = prop.value;
                    }
                    textarea.addEventListener("blur", function () {
                        this.value = this.value.trim();
                    });
                    action.appendChild(textarea);
                    card.appendChild(action);
                    return card;
                },
                [PropertyType.SINGLESELECT]: () => {
                    const {id, card, action} = this.#getPropertyComponents(prop, displayName);
                    const select = document.createElement("select");
                    select.id = `${id}-action`;
                    select.disabled = this.#readOnly;
                    select.classList.add("form-control");
                    select.addEventListener("change", () => this.#singleselectChanged(prop.idx));
                    // this logic prevents the selection of the default option 'Deine Auswahl...'
                    if (!(prop.flags.includes(REQUIRED_FLAG) && prop.value && prop.value.length > 0)) {
                        select.innerHTML += `<option ${prop.flags.includes(REQUIRED_FLAG) ? 'disabled' : ''} selected value>Deine Auswahl…</option>`; // if required -> disabled, if nothing is selected -> show/select, if required and something is selected -> hide
                    }
                    prop.propertyListElementDTOs.sort(function (a, b) {
                        return a.priority - b.priority
                    }).forEach(pListElement => {
                        select.innerHTML += `
                                        <option
                                            value="${pListElement.publicId}"
                                            ${prop.value && prop.value.includes(pListElement.publicId) ? "selected" : ""}>
                                                ${pListElement.name}
                                        </option>`;
                    });
                    action.appendChild(select);
                    card.appendChild(action);
                    return card;
                },
                [PropertyType.MULTISELECT]: () => {
                    const {id, card, action} = this.#getPropertyComponents(prop, displayName);
                    const actionDiv = document.createElement("div");
                    actionDiv.id = `${id}-action`;
                    actionDiv.style.width = "100%";
                    actionDiv.classList.add("sirius-select", "multi-select");
                    const formDiv = document.createElement("div");
                    formDiv.className = "form-group";

                    const inputElement = document.createElement("input");
                    inputElement.id = `${id}-action-input`;
                    inputElement.type = "text";
                    inputElement.autocomplete = "off";
                    inputElement.className = "form-control input-block-level";
                    inputElement.readOnly = this.#readOnly;
                    inputElement.value = "";
                    inputElement.onchange = () => this.#multiselectChanged(prop.idx);

                    formDiv.appendChild(inputElement);
                    actionDiv.appendChild(formDiv);
                    action.appendChild(actionDiv);

                    const select = document.createElement("select");
                    select.id = `${id}-action-suggestions-select`;
                    select.setAttribute("multiple", "multiple");
                    select.style.display = "none";
                    prop.propertyListElementDTOs.sort(function (a, b) {
                        return a.priority - b.priority
                    }).forEach(pListElement => {
                        select.innerHTML += `
                                        <option
                                            value="${pListElement.publicId}"
                                            ${prop.value && prop.value.includes(pListElement.publicId) ? "selected" : ""}>
                                                ${pListElement.name}
                                                </option>`;
                    });
                    action.appendChild(select);
                    card.appendChild(action);
                    return card;
                },
            };
            const propElement = propsByType[type]();
            this.#appendToContent(propElement);

            // Init tooltip
            let ttipId = `property-${prop.idx}-${prop.type.toLowerCase()}-ttid`;
            tippy('#' + ttipId, {
                interactive: true,
                placement: 'right',
                animation: 'scale-extreme',
                theme: 'mmttip',
                maxWidth: 367,
                appendTo: this.#root.querySelector("#mp-content")
            });

            // Init multiselect
            if (type === PropertyType.MULTISELECT) {
                multiSelect({
                    id: `${propElement.id}-action`,
                    noMatchesText: 'Keine Suchtreffer…',
                    readonly: this.#readOnly,
                    placeholder: 'Deine Auswahl (mehrere)…',
                    keepInputOnSelect: true,
                    autocomplete: false
                });
                // Mitigates a bug, when an option is deselected in the dropdown, the change event is not triggered
                this.#root.querySelector("#" + propElement.id + "-action-input-tokenfield").addEventListener("focusout", () => this.#multiselectChanged(prop.idx));
                // Needed because of the display: block in the css file (which is also needed!). Otherwise, on first load, there is an ugly fragment visible
                const completion = this.#root.querySelector("#" + propElement.id + "-action-completion");
                if (completion) {
                    completion.style.display = "none";
                }
                this.#multiselectChanged(prop.idx);
            } else if (type === PropertyType.SINGLESELECT) {
                this.#singleselectChanged(prop.idx);
            }
        }
    }

    #removeProperty(prop) {
        const elementToRemove = this.#root.querySelector(`#property-${prop.idx}-${prop.type.toLowerCase()}`);
        if (elementToRemove) {
            elementToRemove.style.animation = "mp-remove-item .6s forwards";
            setTimeout(() => {
                elementToRemove.remove();
            }, 600);

            // Recursive removal of children
            prop.propertyListElementDTOs?.forEach(listElement => {
                listElement.propertyChildren.forEach(propChild => {
                    this.#removeProperty(propChild);
                })
            });
        }
    }

    /**
     * Call to check all properties.
     * If all are successful, collect data from all properties and dispatch via custom event.
     */
    checkPropsAndDispatchEvent() {
        if (!this.#invalidateProps()) {
            return;
        }

        const allProps = [];

        this.fetchedProperties.forEach(rootProp => {
            let resProp = this.#collectPropertiesRecursively(rootProp);
            allProps.push(resProp);
        });

        const propsSaveEvent = new CustomEvent('materialPropertiesSave', {
            detail: {
                materialId: this.#materialId,
                data: allProps,
            }
        });

        window.dispatchEvent(propsSaveEvent);
        $('#materialPropertiesModal').modal('hide');
    }

    /**
     * Fetches properties hierarchically, for a given node.
     */
    #collectPropertiesRecursively(prop) {
        if (!prop) {
            return;
        }
        const propData = {
            publicId: prop.publicId,
            name: prop.name,
            displayName: prop.displayName,
            description: prop.description,
            type: prop.type,
            flags: prop.flags,
            required: prop.flags.includes(REQUIRED_FLAG) && this.#enforceRequiredFields,
            priority: prop.priority,
        };
        const actionId = `property-${prop.idx}-${prop.type.toLowerCase()}-action`;
        switch (prop.type) {
            case PropertyType.RANGE:
                propData.value = {
                    from: this.#root.querySelector(`#${actionId}-from`).value,
                    to: this.#root.querySelector(`#${actionId}-to`).value,
                };
                break;
            case PropertyType.NUMBER:
            case PropertyType.STRING:
                propData.value = this.#root.querySelector(`#${actionId}`).value;
                break;
            case PropertyType.SINGLESELECT:
            case PropertyType.MULTISELECT:
                let listElements;
                if (prop.type === PropertyType.SINGLESELECT) {
                    listElements = Array.from(this.#root.querySelector(`#${actionId}`).options).filter(e => e.value);
                } else {
                    listElements = Array.from(this.#root.querySelector(`#${actionId}-suggestions-select`).options).filter(e => e.value);
                }
                propData.value = listElements.filter(e => e.selected).map(e => e.value);
                propData.propertyListElementDTOs = listElements.map(e => {
                    const listElementDTO = prop.propertyListElementDTOs.find(dto => dto.publicId === e.value);
                    const propChildren = listElementDTO.propertyChildren;
                    return {
                        publicId: listElementDTO.publicId,
                        name: listElementDTO.name,
                        propertyId: listElementDTO.propertyId,
                        priority: listElementDTO.priority,
                        propertyChildren: propChildren.map(child => {
                            const propChildElement = this.#root.querySelector(`#property-${child.idx}-${child.type.toLowerCase()}`);
                            if (propChildElement) {
                                return this.#collectPropertiesRecursively(child);
                            }
                            return child;
                        }).filter(Boolean),
                    };
                });
                break;
        }

        return propData;
    }

    /**
     * Dynamically adding/removing properties
     */
    #singleselectChanged(idx) {
        const options = Array.from(this.#root.querySelector(`#property-${idx}-singleselect-action`).options)
            .filter(o => o.value);
        options.forEach(option => {
            const oElement = this.fetchedPropsMapping[idx].propertyListElementDTOs.find(e => e.publicId === option.value);
            if (option.selected) {
                oElement.propertyChildren.forEach(propChild => {
                    const existingPropChild = this.#root.querySelector(`#property-${propChild.idx}-${propChild.type.toLowerCase()}`);
                    if (!existingPropChild) {
                        const displayName = `${this.fetchedPropsMapping[idx].displayName ?? this.fetchedPropsMapping[idx].name} (${oElement.displayName ?? oElement.name}) &rarr; ${propChild.displayName ?? propChild.name}`;
                        this.#addProperty(propChild, displayName);
                    }
                });
            } else {
                oElement.propertyChildren.forEach(prop => {
                    this.#removeProperty(prop);
                });
            }
        });
    }

    #multiselectChanged(idx) {
        const options = Array.from(this.#root.querySelector(`#property-${idx}-multiselect-action-suggestions-select`).options)
            .filter(o => o.value);
        options.forEach(option => {
            const oElement = this.fetchedPropsMapping[idx].propertyListElementDTOs.find(e => e.publicId === option.value);
            if (option.selected) {
                oElement.propertyChildren.forEach(propChild => {
                    const existingPropChild = this.#root.querySelector(`#property-${propChild.idx}-${propChild.type.toLowerCase()}`);
                    if (!existingPropChild) {
                        const displayName = `${this.fetchedPropsMapping[idx].displayName ?? this.fetchedPropsMapping[idx].name} (${oElement.displayName ?? oElement.name}) &rarr; ${propChild.displayName ?? propChild.name}`;
                        this.#addProperty(propChild, displayName);
                    }
                });
            } else {
                oElement.propertyChildren.forEach(prop => {
                    this.#removeProperty(prop);
                });
            }
        });
    }


    /**
     * VALIDATION
     */

    #invalidateProps() {
        this.#clearAllErrors();
        const props = Array.from(this.#root.querySelector("#mp-content").children);
        const errorList = props.flatMap(prop => this.#validateProp(prop) || []);

        if (errorList.length > 0) {
            errorList.forEach(this.#displayError);
            return false;
        }
        return true;
    }

    #validateProp(prop) {
        const required = prop.querySelector("label").classList.contains("input-required");
        switch (this.#getPropType(prop)) {
            case PropertyType.RANGE:
                return this.#validateRange(prop, required);
            case PropertyType.NUMBER:
                return this.#validateNumber(prop, required);
            case PropertyType.STRING:
                return this.#validateString(prop, required);
            case PropertyType.SINGLESELECT:
                return this.#validateSingleselect(prop, required);
            case PropertyType.MULTISELECT:
                return this.#validateMultiselect(prop, required);
            default:
                return null;
        }
    }

    #validateRange(prop, required) {
        let from = prop.querySelector("#" + prop.id + "-action-from").value;
        let to = prop.querySelector("#" + prop.id + "-action-to").value;
        // if values are empty set to null
        if (from === "") {
            from = null
        }
        if (to === "") {
            to = null
        }
        if (required) {
            if (from !== null && !from || to !== null && !to || from === null && to === null) {
                return {prop: prop, text: errRequiredMsg};
            }
        }
        try {
            // check if to range value is not smaller as from and both values are filled
            if (Number(to) < Number(from) && to !== null && from !== null) {
                return {prop: prop, text: errCompareMsg};
            }
            // and check if only to is filled and higher than 0
            if (from === null && to !== null && to == 0) {
                return {prop: prop, text: errCanNotBeZeroMsg};
            }
        } catch (e) {
            return {prop: prop, text: errInvalidMsg};
        }
        return null;
    }

    #validateNumber(prop, required) {
        if (required) {
            const numberValue = prop.querySelector("#" + prop.id + "-action").value;
            if (!numberValue) {
                return {prop: prop, text: "Dies ist ein Pflichtfeld."};
            }
        }
        return null;
    }

    #validateString(prop, required) {
        if (required) {
            const stringValue = prop.querySelector("#" + prop.id + "-action").value.trim();
            if (!stringValue) {
                return {prop: prop, text: "Dies ist ein Pflichtfeld."};
            }
        }
        return null;
    }

    #validateSingleselect(prop, required) {
        if (required) {
            const singleselectValue = prop.querySelector("#" + prop.id + "-action").value;
            if (!singleselectValue) {
                return {prop: prop, text: "Dies ist ein Pflichtfeld."};
            }
        }
        return null;
    }

    #validateMultiselect(prop, required) {
        if (required) {
            const options = prop.querySelector("#" + prop.id + "-action-suggestions-select").selectedOptions;
            if (options.length === 0) {
                return {id: prop.id, text: "Dies ist ein Pflichtfeld."};
            } else if (options.length === 1) { // Somehow, there is an empty option added when no options are selected, so we need to check that in this case
                if (!options[0].value) {
                    return {prop: prop, text: "Dies ist ein Pflichtfeld."};
                }
            }
        }
        return null;
    }


    /**
     * UTILITY
     */
    #getPropertyComponents(prop, displayName) {
        const id = `property-${prop.idx}-${prop.type.toLowerCase()}`;
        const card = this.#getPropertyCardTemplate(prop, id, displayName ?? (prop.displayName && prop.displayName !== "" ? prop.displayName : prop.name));
        const action = this.#getActionElement();

        return {id, card, action};
    }

    resetContent() {
        $(this.#root.querySelector("#mp-content")).empty();
        this.fetchedProperties = [];
        this.fetchedPropsMapping = {};
        this.#root.querySelector("#mp-btn-save")?.classList.remove("disabled");
    }

    #appendToContent(element) {
        $(this.#root.querySelector("#mp-content")).append(element);
    }

    #showNoProperties() {
        const noPropsSpan = document.createElement("span");
        noPropsSpan.innerText = "Zu diesem Material existieren keine Eigenschaften.";
        $(this.#root.querySelector("#mp-content")).append(noPropsSpan);
        this.#root.querySelector("#mp-btn-save")?.classList.add("disabled");
    }

    #showNoPropertiesWithError(message, showReloadButton = false) {
        const errorDiv = document.createElement("div");
        const noPropsSpan = document.createElement("span");
        noPropsSpan.innerText = message;
        errorDiv.append(noPropsSpan);
        this.#root.querySelector("#mp-btn-save")?.classList.add("disabled");
        if (showReloadButton) {
            const reloadButton = document.createElement("button");
            reloadButton.classList.add("btn", "btn-primary", "btn-elevated");
            reloadButton.addEventListener("click", () => {
                window.location.reload();
            });
            reloadButton.innerText = "Neu laden";
            reloadButton.style.marginLeft = "12px";
            errorDiv.append(reloadButton);
        }
        $(this.#root.querySelector("#mp-content")).append(errorDiv);
    }

    #getPropertyCardTemplate(prop, id, name) {
        let templateString = `<div id="${id}" class="row card mp-property-card" data-idx="${prop.idx}" style="order: ${prop.idx}; z-index: ${this.#orderIdx - prop.idx}">
                <div class="col mp-property-label-col">
                    <label style="width: ${prop.description ? '90%' : '100%'}"`;
        if (prop.flags.includes(REQUIRED_FLAG) && this.#enforceRequiredFields) {
            templateString += ` class="input-required"`;
        }
        templateString += `>${name}</label>`;
        if (prop.description) {
            templateString += `<div id="property-${prop.idx}-${prop.type.toLowerCase()}-ttid" data-tippy-content="${prop.description}" class="info-icon"></div>`;
        }
        templateString += `</div></div>`;
        const template = document.createElement("template");
        template.innerHTML = templateString.trim();
        return template.content.firstChild;
    }

    #getActionElement() {
        const action = document.createElement("div");
        action.classList.add("col", "mp-action-box");
        return action;
    }

    #getNumberInputElement(id, placeholder = "", classList = [], value = null) {
        const input = document.createElement("input");
        input.id = id;
        input.placeholder = placeholder;
        input.type = "number";
        input.disabled = this.#readOnly;
        input.classList.add(...classList);
        if (value || value === 0) {
            input.value = value;
        }
        return input;
    }

    #getPropType(prop) {
        const propTypeIdString = prop.id.split("-");
        if (propTypeIdString.length < 3) {
            return PropertyType.NONE;
        } else {
            const type = propTypeIdString[propTypeIdString.length - 1].toUpperCase();
            if (!PropertyType[type]) {
                return PropertyType.NONE;
            }
            return PropertyType[type];
        }
    }

    #displayError(pError) {
        const errorSpan = document.createElement("span");
        errorSpan.classList.add("mp-error-span");
        errorSpan.innerText = pError.text;
        pError.prop.appendChild(errorSpan);
    }

    #clearAllErrors() {
        this.#root.querySelectorAll(".mp-error-span")?.forEach(e => e.remove());
    }

}

window.MaterialPropertiesModal = MaterialPropertiesModal
